
const Focus = {
	clear() {
		document.activeElement?.blur()
	},
}

export default Focus
